import { createContext } from 'react';
export const WeeklySalesContext = createContext(null);
